"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToUnits = exports.deleteUnitRealTime = exports.editUnitRealTime = exports.addUnitRealTime = exports.editUnit = exports.deleteUnit = exports.addUnit = exports.fetchUnitsByWarehouseId = exports.fetchUnitsInBatches = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var initialState = {
    data: [],
    status: "idle",
    error: null,
    globalUnitsData: {},
    loaded: false,
};
// Fetch all units in batches
exports.fetchUnitsInBatches = (0, toolkit_1.createAsyncThunk)("units_warehouses/fetchUnitsInBatches", function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.from("units_warehouses").select("*")];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch units by warehouse ID
exports.fetchUnitsByWarehouseId = (0, toolkit_1.createAsyncThunk)("units_warehouses/fetchUnitsByWarehouseId", function (warehouseId, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("units_warehouses")
                    .select("*")
                    .eq("warehouseId", warehouseId)];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
        }
    });
}); });
// Add a new unit
exports.addUnit = (0, toolkit_1.createAsyncThunk)("units_warehouses/addUnit", function (newUnit, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, insertData, insertError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("units_warehouses")
                    .insert(newUnit)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), insertData = _a.data, insertError = _a.error;
                if (insertError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(insertError.message)];
                }
                return [2 /*return*/, insertData];
        }
    });
}); });
// Delete a unit
exports.deleteUnit = (0, toolkit_1.createAsyncThunk)("units_warehouses/deleteUnit", function (id, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("units_warehouses")
                    .delete()
                    .eq("id", id)];
            case 1:
                error = (_a.sent()).error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, id];
        }
    });
}); });
// Edit a unit
exports.editUnit = (0, toolkit_1.createAsyncThunk)("units_warehouses/editUnit", function (updatedUnit, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, updateData, updateError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("units_warehouses")
                    .update(updatedUnit)
                    .eq("id", updatedUnit.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), updateData = _a.data, updateError = _a.error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, updateData];
        }
    });
}); });
// Real-time actions
var addUnitRealTime = function (newUnit) { return ({
    type: "units_warehouses/addUnitRealTime",
    payload: newUnit,
}); };
exports.addUnitRealTime = addUnitRealTime;
var editUnitRealTime = function (updatedUnit) { return ({
    type: "units_warehouses/editUnitRealTime",
    payload: updatedUnit,
}); };
exports.editUnitRealTime = editUnitRealTime;
var deleteUnitRealTime = function (id) { return ({
    type: "units_warehouses/deleteUnitRealTime",
    payload: id,
}); };
exports.deleteUnitRealTime = deleteUnitRealTime;
// Slice definition
var unitsSlice = (0, toolkit_1.createSlice)({
    name: "units_warehouses",
    initialState: initialState,
    reducers: {
        addUnitRealTime: function (state, action) {
            var exists = state.data.some(function (unit) { return unit.id === action.payload.id; });
            if (!exists) {
                state.data.push(action.payload);
            }
            state.error = null;
        },
        editUnitRealTime: function (state, action) {
            var index = state.data.findIndex(function (unit) { return unit.id === action.payload.id; });
            if (index !== -1) {
                var isDifferent = JSON.stringify(state.data[index]) !== JSON.stringify(action.payload);
                if (isDifferent) {
                    state.data[index] = action.payload;
                }
            }
            state.error = null;
        },
        deleteUnitRealTime: function (state, action) {
            var exists = state.data.some(function (unit) { return unit.id === action.payload; });
            if (exists) {
                state.data = state.data.filter(function (unit) { return unit.id !== action.payload; });
            }
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            // fetch all units
            .addCase(exports.fetchUnitsInBatches.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchUnitsInBatches.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            action.payload.forEach(function (unit) {
                var _a;
                state.globalUnitsData[(_a = unit.id) !== null && _a !== void 0 ? _a : ""] = unit;
            });
        })
            .addCase(exports.fetchUnitsInBatches.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch units.";
        })
            // Handle fetchUnitsByWarehouseId
            .addCase(exports.fetchUnitsByWarehouseId.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchUnitsByWarehouseId.fulfilled, function (state, action) {
            state.status = "succeeded";
            state.data = action.payload;
            state.error = null;
        })
            .addCase(exports.fetchUnitsByWarehouseId.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch units by warehouse.";
        })
            // Handle addUnit
            .addCase(exports.addUnit.fulfilled, function (state, action) {
            state.data.push(action.payload);
            state.error = null;
        })
            .addCase(exports.addUnit.rejected, function (state, action) {
            state.error = action.payload || "Failed to add unit.";
        })
            // Handle deleteUnit
            .addCase(exports.deleteUnit.fulfilled, function (state, action) {
            state.data = state.data.filter(function (unit) { return unit.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deleteUnit.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete unit.";
        })
            // Handle editUnit
            .addCase(exports.editUnit.fulfilled, function (state, action) {
            var index = state.data.findIndex(function (unit) { return unit.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        })
            .addCase(exports.editUnit.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit unit.";
        });
    },
});
// Real-time subscription function
var subscribeToUnits = function (dispatch) {
    var subscription = supabaseClient_1.supabase
        .channel("public:units_warehouses")
        .on("postgres_changes", { event: "*", schema: "public", table: "units_warehouses" }, function (payload) {
        var _a;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addUnitRealTime)(newRecord));
                break;
            case "UPDATE":
                dispatch((0, exports.editUnitRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deleteUnitRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToUnits = subscribeToUnits;
exports.default = unitsSlice.reducer;
